<template>
  <div class="app-container" v-show="isLogin">
    <div style="text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        <el-table
          v-loading="listLoading"
          :data="list"
          highlight-current-row
          style="color: rgb(70, 70, 70); margin-top: 10px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <el-table-column label="主/子账号信息" align="left" min-width="3">
            <template slot-scope="{ row }">
              <span>{{ row.isParOrChild }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拍单账号" min-width="3" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.tk_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否关联" min-width="3" align="left">
            <template slot-scope="{ row }">
              <span v-if="row.is_banned == '0'" style="color: green">已关联云仓账号</span>
              <span v-if="row.is_banned == '1'">
                <el-button
                  type="primary"
                  style="padding-left: 8px; padding-right: 8px"
                  size="mini"
                  @click="handleUpdate(row)"
                >
                  关联
                </el-button></span
              >
            </template>
          </el-table-column>
          <el-table-column label="云仓账户名" min-width="3" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.name">{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="余额" min-width="2" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.user_balance }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page"
          layout="total, prev, pager, next"
          style="padding-top: 12px; padding-bottom: 0px; text-align: center"
          @pagination="getList"
        />
      </div>

      <el-dialog
        :title="glTitle"
        :visible.sync="dialogFormVisible"
        style="width: 80%; margin-left: 10%; margin-top: 8%; text-align: center"
      >
        <el-form
          ref="dataForm"
          :model="temp"
          label-width="120px"
          style="width: 90%; text-align: left"
        >
          <el-form-item label="说明：" prop=""
            ><span style="color: red"
              >拍单子账号关联云仓子账号，中转仓或礼品单下单余额使用子账号云仓余额。<br />
              云仓子账号登入账号密码和拍单软件子账号一致</span
            ></el-form-item
          >
          <el-form-item label="关联云仓账户名:" prop="name" style="height: 20px"
            ><span style="color: green">{{ temp.name }}</span></el-form-item
          >
          <el-form-item label="关联云仓子账号:" prop="tk_name" style="height: 20px"
            ><span style="color: green">{{ temp.tk_name }}</span>
          </el-form-item>
          <el-form-item label="关联云仓密码:" prop="" style="height: 20px"
            ><span style="color: green">同拍单软件一致</span></el-form-item
          >
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" style="margin-right: 20%" @click="updateUserInfo()">
            确认关联
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "bind",
  components: {
    Pagination,
  },
  directives: { waves },
  data() {
    return {
      isLogin: false,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        type: 3,
        page: 1,
        // perPage: 20,
        order: "",
        status: 4,
      },
      dialogFormVisible: false,
      temp: {
        id: undefined,
        name: 0,
        tk_name: "",
      },
      glTitle: "",
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
  },
  methods: {
    getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/getUserInfo";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          // if (resd.data.length > 0) {
          if (resd.code == 200) {
            const child_users = resd.data.child_users;
            const parentUser = resd.data.parent_user;

            let pushData = {
              id: resd.data.id,
              isParOrChild: "拍单主账号",
              tk_name: resd.data.tk_name,
              is_banned: resd.data.is_banned,
              name: resd.data.name,
              user_balance: resd.data.user_balance,
            };
            if (parentUser) {
              pushData.isParOrChild = "拍单子账号";
            }              
            this.list.push(pushData);

            if (child_users && child_users.length > 0) {
              child_users.forEach((item) => {
                if (item != null) {
                  let pushData = {
                    id: item.id,
                    isParOrChild: "拍单子账号",
                    tk_name: item.tk_name,
                    is_banned: item.is_banned,
                    name: item.name,
                    user_balance: item.user_balance,
                  };
                  this.list.push(pushData);
                }
              });
            }
            // if (
            //   parentUser != "" &&
            //   parentUser != null &&
            //   parentUser != "null" &&
            //   parentUser != undefined &&
            //   parentUser != "undefined"
            // ) {
            //   parentUser.isParOrChild = "拍单主账号";
            //   this.list.push(parentUser);
            //   let own = {
            //     isParOrChild: "拍单子账号",
            //     tk_name: resd.data.tk_name,
            //     is_banned: resd.data.is_banned,
            //     name: resd.data.name,
            //     user_balance: resd.data.user_balance,
            //   };
            //   this.list.push(own);
            // } else if (
            //   child_users != "" &&
            //   child_users != null &&
            //   child_users != "null" &&
            //   child_users != undefined &&
            //   child_users != "undefined"
            // ) {
            //   let own = {
            //     isParOrChild: "拍单主账号",
            //     tk_name: resd.data.tk_name,
            //     is_banned: resd.data.is_banned,
            //     name: resd.data.name,
            //     user_balance: resd.data.user_balance,
            //   };
            //   this.list.push(own);
            //   child_users.forEach((item) => {
            //     item.isParOrChild = "拍单子账号";
            //     this.list.push(item);
            //   });
            // }
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    // 打开关联框
    handleUpdate(row) {
      this.dialogFormVisible = true;
      let data = Object.assign({}, row); // copy obj
      this.glTitle = data.isParOrChild + ":" + data.tk_name;
      this.temp = data;
    },
    //确认关联
    updateUserInfo() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      const url = this.$root.commonPreUrl + "/index/updateUserInfo";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: { id: this.temp.id, is_banned: 0 },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            // if (resd.code == "200") {
            this.$notify({
              title: "成功",
              message: resd.message,
              type: "success",
              duration: 2000,
            });
            this.dialogFormVisible = false;
            this.getList();
          } else {
            this.$confirm(resd.message, "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {})
              .catch(() => {});
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

.spanColors {
  /* color: #409eff; */
  font-weight: bold;
  border-top: rgb(221, 221, 221) 1px solid;
  border-right: rgb(221, 221, 221) 1px solid;
  border-left: rgb(221, 221, 221) 1px solid;
  border-bottom: white 2px solid;
  border-top-left-radius: 0.3em;
  border-top-right-radius: 0.3em;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/syncOrder/bind/index.vue